import { Button, Col, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useAnnotations } from "../contexts/AnnotationsContext";

function BookmarksTab(props) {
  const { bookmarks: annotationBookmarks, removeBookmark } = useAnnotations();
  const bookmarks = [];

  for (let i = 0; i < annotationBookmarks.length; i++) {
    bookmarks.push(
      <Row key={annotationBookmarks[i].location}>
        <Col style={{ overflowWrap: "anywhere" }}>
          <a
            href="#"
            data-cfi={annotationBookmarks[i].location}
            onClick={props.onBookmarkLinkClicked}
          >
            {annotationBookmarks[i].text}
          </a>
        </Col>
        <Col xs={2}>
          <Button
            variant="link"
            onClick={() => removeBookmark(annotationBookmarks[i].location)}
            aria-label="Delete bookmark"
          >
            <FontAwesomeIcon icon={faTrashAlt} size="1x" role="presentation" />
          </Button>
        </Col>
      </Row>,
    );
  }

  return (
    <Container>
      <>{bookmarks.length > 0 ? bookmarks : "No Bookmarks"}</>
    </Container>
  );
}

export default BookmarksTab;
